<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Indicadores APS"
            description="Indicadores de qualidade, vínculo e acompanhamento dos cidadãos."
            url="/dashboard"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import ResultadoIsf from '@/components/icons/IndicadoresAps/ResultadoIsf.vue'
import ResultadoIndicadores from '@/components/icons/IndicadoresAps/ResultadoIndicadores.vue'
import DesempenhoPorEquipe from '@/components/icons/IndicadoresAps/DesempenhoPorEquipe.vue'
import PrimeiraConsultaProgramada from '@/components/icons/IndicadoresEsb/Estrategicos/PrimeiraConsultaProgramada'
import TratamentosConcluidos from '@/components/icons/IndicadoresEsb/Estrategicos/TratamentosConcluidos'
import Exodontias from '@/components/icons/IndicadoresEsb/Estrategicos/Exodontias'
import EscovacaoSupervisionada from '@/components/icons/IndicadoresEsb/Estrategicos/EscovacaoSupervisionada'
import Prevencao from '@/components/icons/IndicadoresEsb/Ampliados/Prevencao'
import TratamentosRestauradoresArt from '@/components/icons/IndicadoresEsb/Ampliados/TratamentosRestauradoresArt'

export default {
  name: 'AcsIndicadoresAps',
  components: {
    Menu,
    Footer,
    SectionTitle,
    ResultadoIsf,
    ResultadoIndicadores,
    DesempenhoPorEquipe,
    PrimeiraConsultaProgramada,
    TratamentosConcluidos,
    Exodontias,
    EscovacaoSupervisionada,
    Prevencao,
    TratamentosRestauradoresArt,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.indicadores_aps
      ) {
        const dataClone = [...this.$store.state.permissoes.indicadores_aps]
        return dataClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  data() {
    return {}
  },
  methods: {
    getRibbonColor(item) {
      switch (item.text) {
        case 'ESF':
          return 'blue'
          break
        case 'eSB':
          return 'green'
          break
        case 'eMulti':
          return 'orange'
          break
        default:
          return 'blue'
          break
      }
    },
  },
}
</script>

<style></style>
